module.exports = __webpack_public_path__ + "static/media/Octocat.5d292e21.jpg";